import {FC} from "react";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowDownLong,
    faArrowUpLong, faBusinessTime,
    faCancel,
    faCheck, faFileExcel,
    faList, faListCheck, faLock,
    faMinus,
    faPencil,
    faPlus,
    faPrint, faSave,
    faTrash, faUnlock, faUserPlus
} from "@fortawesome/free-solid-svg-icons";
import {SizeProp} from "@fortawesome/fontawesome-svg-core";

interface Props {
    icon?: React.ReactElement;
    onClick: VoidFunction;
    disabled?: boolean;
    visible?: boolean;
    small?: boolean;
    variant?: string;
    iconSize?: SizeProp;
    title?: string;
    className?: string; // allow passing className through to Button
}

const IconButton: FC<Props> = (props) => {
    if (props.visible || props.visible === undefined)
        return (
            <Button onClick={props.onClick} size={props.small ? "sm" : undefined} disabled={props.disabled}
                    variant={props.variant} className={props.className} title={props.title}>
                {props.icon}
            </Button>
        )

    return null;
}


export const AddIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faPlus}/>} variant={"primary"}/>);
export const PrintIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faPrint}/>} variant={"outline-primary"}/>);
export const XlsIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faFileExcel}/>} variant={"outline-primary"}/>);
export const SubIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faMinus}/>} variant={"danger"}/>);
export const EditIconButton: FC<Props> = (props) => (
    <IconButton  variant={"outline-secondary"} {...props} icon={<FontAwesomeIcon icon={faPencil}/>}/>);
export const BusinessTimeIconButton: FC<Props> = (props) => (
    <IconButton  variant={"outline-secondary"} {...props}
                 icon={<FontAwesomeIcon icon={faBusinessTime} size={props.iconSize} />}
    />);
export const ListIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faList}/>} variant={"outline-secondary"}/>);
export const DeleteIconButton: FC<Props> = (props) => (
    <IconButton variant={"outline-danger"} {...props} icon={<FontAwesomeIcon icon={faTrash}/>}/>);
export const CheckIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faCheck}/>} variant={"primary"}/>);
export const ListCheckIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faListCheck} size={props.iconSize}/>} variant={"primary"}/>);
export const UserPlusIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faUserPlus} size={props.iconSize}/>} variant={"primary"}/>);
export const CancelIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faCancel} size={props.iconSize}/>} variant={"danger"}/>);

export const SaveIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faSave}/>} variant={"success"}/>);

export const ConfirmIconButton: FC<Props & {
    onReject: VoidFunction;
    approveTitle?: string;
    rejectTitle?: string;
}> = (props) => (
        <>
            <CheckIconButton small={props.small} onClick={props.onClick} title={props.approveTitle}/>&nbsp;
            <CancelIconButton small={props.small} onClick={props.onReject} title={props.rejectTitle}/>
        </>
    )
;
export const UpArrowIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faArrowUpLong}/>} variant={"outline-secondary"}/>);
export const DownArrowIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faArrowDownLong}/>} variant={"outline-secondary"}/>);
export const LockIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faLock}/>} small variant={"outline-danger"}/>);
export const UnlockIconButton: FC<Props> = (props) => (
    <IconButton {...props} icon={<FontAwesomeIcon icon={faUnlock}/>} small variant={"outline-primary"}/>);

export default IconButton;
